<div >
  <!-- Onboarding Section -->
  <div class="crm-onboarding-form">
    <div class="container-fluid bg-transparent p-0 h-100">
      <div class="row h-100 g-0">
         <!-- Left: Image + Overlay For TrustFirst -->
        <div
          v-if="current_domain === 'trustfirst'"
          class="col-lg-6 d-none d-lg-flex align-items-center justify-content-center position-relative p-0 h-100"
        >
          <!-- Overlay Text -->
          <div
            class="overlay-text d-flex flex-column justify-content-center align-items-center"
          >
            <img :src="$clientLogo" class="img-fluid" width="230" />
            <h4 data-aos="fade-up" class="lh-sm green-color mb-3 mt-4">
              <span class="green-color fw-bold"
                >Start your Trust Journey with us</span
              >
            </h4>
            <p
              data-aos="fade-up"
              data-aos-delay="100"
              class="text-white px-1"
            >
              Discover easy, secure, and professional solutions for creating
              and managing Trusts and Trust assets. <br />
              Let our experienced team help you set up the right Trust for
              your needs.
            </p>
            <div
              class="d-flex justify-content-center gap-4 mt-5 overlay-image-row"
            >
              <div class="d-flex align-items-center overlay-image-card">
                <img
                  src="@/assets/images/trustfirst/pictures/automation.png"
                  alt="Automate Gear"
                  width="20"
                  class="me-1"
                />
                <span class="overlay-image-text text-white text-x fw-bold"
                  >Automate</span
                >
              </div>
              <div class="d-flex align-items-center overlay-image-card">
                <img
                  src="@/assets/images/trustfirst/pictures/verified-user.png"
                  alt="Verified User"
                  width="20"
                  class="me-1"
                />
                <span class="overlay-image-text text-white text-x fw-bold"
                  >Verify</span
                >
              </div>
              <div class="d-flex align-items-center overlay-image-card">
                <img
                  src="@/assets/images/trustfirst/pictures/complaint.png"
                  alt="Compliant"
                  width="20"
                  class="me-1"
                />
                <span class="overlay-image-text text-white text-x fw-bold"
                  >Comply</span
                >
              </div>
            </div>
          </div>
        </div>

        <!-- Left: Image + Overlay For X-Verdict -->
        <div
          v-else-if="current_domain === 'x-verdict'"
          class="col-lg-6 d-none d-lg-flex align-items-center justify-content-center position-relative p-0 h-100"
        >
          <!-- Overlay Text -->
          <div
            class="overlay-text d-flex flex-column justify-content-center align-items-center"
          >
            <img :src="$clientLogo" class="img-fluid" width="230" />
            <h4 data-aos="fade-up" class="lh-sm green-color mb-3 mt-4">
              <span class="green-color fw-bold"
                >Start your Case Journey with us</span
              >
            </h4>
            <p
              data-aos="fade-up"
              data-aos-delay="100"
              class="text-white px-1"
            >
              Experience secure, efficient, and professional case management solutions for individuals and organizations.
              Simplify how you track, manage, and resolve your cases — all in one platform.<br />
              Let our expert team help you streamline your case processes from start to finish.
            </p>
            <div
              class="d-flex justify-content-center gap-4 mt-5 overlay-image-row"
            >
              <div class="d-flex align-items-center overlay-image-card">
                <img
                  src="@/assets/images/trustfirst/pictures/automation.png"
                  alt="Automate Gear"
                  width="20"
                  class="me-1"
                />
                <span class="overlay-image-text text-white text-x fw-bold"
                  >Automate</span
                >
              </div>
              <div class="d-flex align-items-center overlay-image-card">
                <img
                  src="@/assets/images/x-verdict/pictures/track-back.png"
                  alt="Verified User"
                  width="20"
                  class="me-1"
                />
                <span class="overlay-image-text text-white text-x fw-bold"
                  >Track</span
                >
              </div>
              <div class="d-flex align-items-center overlay-image-card">
                <img
                  src="@/assets/images/x-verdict/pictures/problem-solving.png"
                  alt="Compliant"
                  width="20"
                  class="me-1"
                />
                <span class="overlay-image-text text-white text-x fw-bold"
                  >Resolve</span
                >
              </div>
            </div>
          </div>
        </div>

        <!-- Left: Image + Overlay For Proba Workflows -->
        <div
          v-else-if="current_domain === 'probaworkflows'"
          class="col-lg-6 d-none d-lg-flex align-items-center justify-content-center position-relative p-0 h-100"
        >
          <!-- Overlay Text -->
          <div
            class="overlay-text d-flex flex-column justify-content-center align-items-center"
          >
            <img :src="$clientLogo" class="img-fluid" width="230" />
            <h4 data-aos="fade-up" class="lh-sm green-color mb-3 mt-4">
              <span class="green-color fw-bold"
                >Streamline Your Workflow Journey with Us</span
              >
            </h4>
            <p
              data-aos="fade-up"
              data-aos-delay="100"
              class="text-white px-1"
            >
              Discover powerful, secure, and automated workflow solutions designed to help your business stay compliant and efficient.
              From request handling to approvals and reporting — manage everything in one smart, connected system.<br />
              Let Proba Workflows simplify how you automate tasks and ensure compliance across your organization.
            </p>
            <div
              class="d-flex justify-content-center gap-4 mt-5 overlay-image-row"
            >
              <div class="d-flex align-items-center overlay-image-card">
                <img
                  src="@/assets/images/trustfirst/pictures/automation.png"
                  alt="Automate Gear"
                  width="20"
                  class="me-1"
                />
                <span class="overlay-image-text text-white text-x fw-bold"
                  >Automate</span
                >
              </div>
              <div class="d-flex align-items-center overlay-image-card">
                <img
                  src="@/assets/images/proba_workflows/pictures/orchestration.png"
                  alt="Verified User"
                  width="20"
                  class="me-1"
                />
                <span class="overlay-image-text text-white text-x fw-bold"
                  >Orchestrate</span
                >
              </div>
              <div class="d-flex align-items-center overlay-image-card">
                <img
                  src="@/assets/images/trustfirst/pictures/complaint.png"
                  alt="Compliant"
                  width="20"
                  class="me-1"
                />
                <span class="overlay-image-text text-white text-x fw-bold"
                  >Comply</span
                >
              </div>
            </div>
          </div>
        </div>

        <!-- Left: Image + Overlay For Ndabeni Trust -->
        <div
          v-else-if="current_domain === 'ndabenitrust'"
          class="col-lg-6 d-none d-lg-flex align-items-center justify-content-center position-relative p-0 h-100"
        >
          <!-- Overlay Text -->
          <div
            class="overlay-text d-flex flex-column justify-content-center align-items-center"
          >
            <img :src="$clientLogo" class="img-fluid" width="230" />
            <h4 data-aos="fade-up" class="lh-sm green-color mb-3 mt-4">
              <span class="green-color fw-bold"
                >Streamline Your Trust Journey with Us</span
              >
            </h4>
            <p
              data-aos="fade-up"
              data-aos-delay="100"
              class="text-white px-1"
            >
              Discover powerful, secure, and automated trust solutions designed to help your business stay compliant and efficient.
              From request handling to approvals and reporting — manage everything in one smart, connected system.<br />
            </p>
            <div
              class="d-flex justify-content-center gap-4 mt-5 overlay-image-row"
            >
              <div class="d-flex align-items-center overlay-image-card">
                <img
                  src="@/assets/images/trustfirst/pictures/automation.png"
                  alt="Automate Gear"
                  width="20"
                  class="me-1"
                />
                <span class="overlay-image-text text-white text-x fw-bold"
                  >Automate</span
                >
              </div>
              <div class="d-flex align-items-center overlay-image-card">
                <img
                  src="@/assets/images/proba_workflows/pictures/orchestration.png"
                  alt="Verified User"
                  width="20"
                  class="me-1"
                />
                <span class="overlay-image-text text-white text-x fw-bold"
                  >Manage</span
                >
              </div>
              <div class="d-flex align-items-center overlay-image-card">
                <img
                  src="@/assets/images/trustfirst/pictures/complaint.png"
                  alt="Compliant"
                  width="20"
                  class="me-1"
                />
                <span class="overlay-image-text text-white text-x fw-bold"
                  >Comply</span
                >
              </div>
            </div>
          </div>
        </div>

        <!-- Right: Form / Success -->
        <div
          v-if="submission_success"
          class="col-12 col-lg-6 crm-form-container d-flex flex-column justify-content-center align-items-center text-center "
        >
          <div class="p-4">
            <i class="fas fa-check-circle text-primary fs-2 mb-3"></i>
            <h4 class="mb-3 fw-bold">Thank you for your enquiry!</h4>
            <p class="text-muted mb-0">
              Our experts will review your request and get back to you soon.
            </p>
          </div>
        </div>
        <div class="col-12 col-lg-6 crm-form-container d-flex flex-column p-5">

          <!-- Scrollable Content Section -->
          <div class="flex-grow-1">
            <div class="mb-4">
              <label for="project_select" class="form-label fw-medium text-xxs"></label>
              <select
                id="project_select"
                class="form-select form-select-sm text-xxs bg-white border py-1 rounded-lg shadow-lg"
                v-model="selected_project"
                @change="on_project_change"
              >
                <option value="" disabled>Select a project</option>
                <option v-for="project in projects" :key="project.id" :value="project.id">
                  {{ project.project_name }}
                </option>
              </select>
            </div>

            <!-- Questions Section with Subtle Border -->
            <div v-if="selected_project && enquiry_form_questions.length" class="rounded-lg p-4 mb-4 glass-card">
              <!-- Fixed Header Section -->
              <div class="text-center">
                <p class="fw-bold ">Make An Enquiry</p>
              </div>            
              
              <form @submit.prevent="submit_enquiry" class="scrollable-form-content">

                <div
                  v-for="question in enquiry_form_questions"
                  :key="question.junction_id"
                  class="mb-3"
                >
                  <label :for="`question_${question.junction_id}`" class="form-label text-xxs fw-medium mb-1">
                    {{ question.title }}
                    <span v-if="question.required" class="text-danger">*</span>
                  </label>

                  <!-- SHORT TEXT / NUMBER / DATE -->
                  <input
                    v-if="['short_text','number','date'].includes(question.type)"
                    :id="`question_${question.junction_id}`"
                    :type="question.type === 'short_text' ? 'text' : question.type"
                    class="form-control form-control-sm text-xxs bg-white border py-1 rounded-lg shadow-sm"
                    v-model="form_data[question.junction_id]"
                    :required="question.required"
                    :placeholder="question.placeholder || 'Your answer...'"
                  />

                  <!-- LONG TEXT -->
                  <textarea
                    v-else-if="question.type === 'long_text'"
                    :id="`question_${question.junction_id}`"
                    class="form-control form-control-sm text-xxs bg-white border py-1 rounded-lg shadow-sm"
                    v-model="form_data[question.junction_id]"
                    :required="question.required"
                    rows="2"
                    :placeholder="question.placeholder || 'Your answer...'"
                  ></textarea>

                  <!-- SINGLE SELECT (Dropdown) -->
                  <select
                    v-else-if="question.type === 'single_select'"
                    :id="`question_${question.junction_id}`"
                    class="form-select form-select-sm text-xxs bg-white border py-1 rounded-lg shadow-sm"
                    v-model="form_data[question.junction_id]"
                    :required="question.required"
                  >
                    <option value="" disabled>Select an option</option>
                    <option v-for="option in question.options" :key="option" :value="option">
                      {{ option }}
                    </option>
                  </select>

                  <!-- MULTI SELECT (as checkboxes) -->
    <div v-else-if="question.type === 'multi_select'" class="d-flex flex-wrap gap-3">
      <div
        v-for="option in question.options"
        :key="option"
        class="form-check"
      >
        <input
          type="checkbox"
          :id="`${question.junction_id}_${option}`"
          class="form-check-input"
          :value="option"
          v-model="form_data[question.junction_id]"
        />
        <label :for="`${question.junction_id}_${option}`" class="form-check-label small">
          {{ option }}
        </label>
      </div>
    </div>

                  <!-- RADIO BUTTONS -->
                  <div v-else-if="question.type === 'radio'" class="d-flex flex-wrap gap-3">
                    <div
                      v-for="option in question.options"
                      :key="option"
                      class="form-check"
                    >
                      <input
                        type="radio"
                        :id="`${question.junction_id}_${option}`"
                        class="form-check-input"
                        :value="option"
                        v-model="form_data[question.junction_id]"
                        :required="question.required"
                      />
                      <label :for="`${question.junction_id}_${option}`" class="form-check-label small">
                        {{ option }}
                      </label>
                    </div>
                  </div>

                  <!-- CHECKBOXES -->
                  <div v-else-if="question.type === 'checkbox'" class="d-flex flex-wrap gap-3">
                    <div
                      v-for="option in question.options"
                      :key="option"
                      class="form-check"
                    >
                      <input
                        type="checkbox"
                        :id="`${question.junction_id}_${option}`"
                        class="form-check-input"
                        :value="option"
                        v-model="form_data[question.junction_id]"
                      />
                      <label :for="`${question.junction_id}_${option}`" class="form-check-label small">
                        {{ option }}
                      </label>
                    </div>
                  </div>

                  <!-- FILE UPLOAD -->
                  <input
                    v-else-if="question.type === 'file'"
                    :id="`question_${question.junction_id}`"
                    type="file"
                    class="form-control form-control-sm text-xxs bg-white border py-1 rounded-lg shadow-sm"
                    @change="handle_file_upload($event, question.junction_id)"
                    :multiple="question.multiple"
                    :required="question.required"
                  />

                  <!-- DEFAULT TEXT INPUT (fallback) -->
                  <input
                    v-else
                    :id="`question_${question.junction_id}`"
                    type="text"
                    class="form-control form-control-sm text-xxs bg-white border py-1 rounded-lg shadow-sm"
                    v-model="form_data[question.junction_id]"
                    :required="question.required"
                    placeholder="Your answer..."
                  />
                </div>

                <!-- Terms -->
                <div v-if="show_terms" class="form-check my-3">
                  <input
                    type="checkbox"
                    id="terms_checkbox"
                    v-model="form_data.terms"
                    class="form-check-input me-2"
                    required
                  />
                  <label for="terms_checkbox" class="text-xxs fw-bold">
                    I have read and understood the contents noted in the
                    <a data-bs-toggle="modal" data-bs-target="#data_privacy_notice" class="text-decoration-underline">
                      Data Privacy Statement
                    </a>
                  </label>
                </div>

                <!-- Submit -->
                <div class="text-center">
                  <button type="submit" class="btn btn-primary-dark btn-sm text-xxs">
                    Submit Enquiry
                  </button>
                </div>

              </form>
            </div>

            <!-- Show message when no project selected or no questions -->
            <div v-else-if="selected_project && !enquiry_form_questions.length" class="text-center p-4 glass-card rounded-lg">
              <p class="text-xxs text-white">No questions available for this project.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Data Privacy Modal -->
<teleport to="body">
<div class="modal fade" id="data_privacy_notice" tabindex="-1" aria-labelledby="create_section_label" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content bg-white rounded-4 shadow-lg border-0">

      <!-- Header -->
      <div class="modal-header cute-header border-bottom-0 shadow-sm rounded-top-4 px-4 py-3">
        <h5 class="modal-title text-white fw-semibold" id="create_project_label">
          Data Privacy Statement
        </h5>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Body -->
      <div class="modal-body p-0 privacy-modal">
        <iframe
          :src="'data:application/pdf;base64,' + privacy_statement"
          width="100%"
          height="100%"
          frameborder="0"
          class="rounded-bottom-4"
        ></iframe>
      </div>
    </div>
  </div>
</div>
</teleport>